import styled from 'styled-components';
import { Select } from 'foundations-components/transitional/components/Select/Select'; //TODO: temp direct import
import { useSelectedObjectTypeDef, useSelectedTypeDefObjectNamesForTranslation } from '../../crmObjects/hooks/useSelectedObjectTypeDef';
import { PriorityRender } from '../../loadable/lib/PriorityRender';
import { Header } from 'foundations-components/transitional/components/Header';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { useIsUngatedForIARedesign } from '../../auth/hooks/useIsUngatedForIARedesign';
import { ObjectIcon } from './ObjectIcon';
import { useMemo } from 'react';
import { DropdownButton } from '../../header/objectSwitcher/components/DropdownButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function LoadingTab({
  children
}) {
  return /*#__PURE__*/_jsx(Flex, {
    flexGrow: 1,
    blockSize: "40px",
    backgroundColor: "fill-surface-default",
    borderColor: "border-core-subtle",
    borderInlineStartWidth: "100",
    borderInlineEndWidth: "100",
    borderBlockStartWidth: "100",
    borderInlineStartStyle: "solid",
    borderInlineEndStyle: "solid",
    borderBlockStartStyle: "solid",
    children: children
  });
}
const LoadingName = styled.div.withConfig({
  displayName: "AsyncHeader__LoadingName",
  componentId: "sc-1dtjd88-0"
})(["height:100%;width:100%;background:linear-gradient( to right,", ",", " 20%,", " 40% );"], ({
  theme
}) => theme.color['fill-tertiary-hover'], ({
  theme
}) => theme.color['fill-tertiary-default'], ({
  theme
}) => theme.color['fill-tertiary-hover']);
const PlaceholderTabs = () => {
  var _useSelectedObjectTyp;
  const {
    pluralForm
  } = useSelectedTypeDefObjectNamesForTranslation();
  const objectTypeId = (_useSelectedObjectTyp = useSelectedObjectTypeDef()) === null || _useSelectedObjectTyp === void 0 ? void 0 : _useSelectedObjectTyp.objectTypeId;
  const hasNewObjectSwitcher = useIsUngatedForIARedesign();
  const CustomButton = useMemo(() => {
    const CustomDropdownButton = props => {
      return /*#__PURE__*/_jsx(DropdownButton, Object.assign({}, props, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(ObjectIcon, {
            objectTypeId: objectTypeId
          }), pluralForm]
        })
      }));
    };
    return CustomDropdownButton;
  }, [objectTypeId, pluralForm]);
  return /*#__PURE__*/_jsx(View, {
    minInlineSize: "100%",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      marginInlineEnd: "300",
      children: [hasNewObjectSwitcher && /*#__PURE__*/_jsx(View, {
        borderInlineEndWidth: "100",
        borderInlineEndStyle: "solid",
        borderInlineEndColor: "border-core-subtle",
        paddingInlineEnd: "300",
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(Dropdown, {
          buttonSize: "small",
          buttonText: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "200",
            children: [/*#__PURE__*/_jsx(ObjectIcon, {
              objectTypeId: objectTypeId
            }), pluralForm]
          }),
          buttonUse: "tertiary-light",
          Button: CustomButton,
          maxBlockSize: "290px",
          "data-test-id": "object-switcher__dropdown",
          disabled: true
        })
      }), /*#__PURE__*/_jsx(LoadingTab, {
        children: /*#__PURE__*/_jsx(LoadingName, {})
      }), /*#__PURE__*/_jsx(LoadingTab, {
        children: /*#__PURE__*/_jsx(LoadingName, {})
      }), /*#__PURE__*/_jsx(LoadingTab, {
        children: /*#__PURE__*/_jsx(LoadingName, {})
      }), /*#__PURE__*/_jsx(LoadingTab, {
        children: /*#__PURE__*/_jsx(LoadingName, {})
      }), /*#__PURE__*/_jsx(LoadingTab, {
        children: /*#__PURE__*/_jsx(LoadingName, {})
      }), hasNewObjectSwitcher && /*#__PURE__*/_jsx(Flex, {
        justifyContent: "end",
        alignItems: "start",
        flexGrow: 1,
        children: /*#__PURE__*/_jsx(Button, {
          use: "primary",
          size: "small",
          disabled: true,
          children: /*#__PURE__*/_jsx(View, {
            blockSize: "14px",
            inlineSize: "80px"
          })
        })
      })]
    })
  });
};
const HeaderPlaceholder = () => {
  const {
    pluralForm
  } = useSelectedTypeDefObjectNamesForTranslation();
  const hasNewObjectSwitcher = useIsUngatedForIARedesign();
  if (!hasNewObjectSwitcher) {
    return /*#__PURE__*/_jsx(Header, {
      marginBlockEnd: "0",
      title: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        justifyContent: "start",
        flexDirection: "row",
        flexWrap: "nowrap",
        children: /*#__PURE__*/_jsx(Select, {
          buttonUse: "link",
          disabled: true,
          placement: "bottom right",
          menuWidth: 350,
          value: pluralForm
        })
      }),
      tabs: /*#__PURE__*/_jsx(PlaceholderTabs, {}),
      children: /*#__PURE__*/_jsx(Flex, {
        justifyContent: "end",
        children: /*#__PURE__*/_jsx(Button, {
          use: "primary",
          disabled: true,
          children: /*#__PURE__*/_jsx(View, {
            blockSize: "12px",
            marginBlockStart: "100",
            inlineSize: "50px"
          })
        })
      })
    });
  } else {
    return /*#__PURE__*/_jsx(Flex, {
      marginInlineStart: "300",
      marginBlockStart: "600",
      children: /*#__PURE__*/_jsx(PlaceholderTabs, {})
    });
  }
};
const loadHeader = () => import( /* webpackChunkName: "header" */'./Header');
const loadHeaderRedesign = () => import( /* webpackChunkName: "header-redesign" */'./HeaderRedesign');
const AsyncRenderHeader = () => {
  const isUngatedForIARedesign = useIsUngatedForIARedesign();
  return /*#__PURE__*/_jsx(PriorityRender, {
    priority: "low",
    LoadingComponent: HeaderPlaceholder,
    loader: isUngatedForIARedesign ? loadHeaderRedesign : loadHeader,
    LOGGING_COMPONENT_NAME: "AsyncHeader"
  });
};
export default AsyncRenderHeader;